import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"


//api
import { TemplateService } from "../../service/template-service"

//components
import { TabMenu } from 'primereact/tabmenu';
import UpdateTemplate from "./components/UpdateTemplate"
import TemplateFiles from "./components/TemplateFiles";

const TemplateDetail = ()=>{
    const {id}= useParams()
    const [template,setTemplate]= useState()
    const [activeIndex, setActiveIndex] = useState(0);
 
    const items = [
        { label: 'Modifica', icon: 'pi pi-pen-to-square' },
        { label: 'File', icon: 'pi pi-file' },
    ];


    //chiamata GET
    useEffect(()=>{
        const fetchTemplate = ()=>{
            TemplateService.getTemplate(
                id,
                (data)=>{
                    setTemplate(data);
                }
            )
        }
        fetchTemplate();
        
    },[id])

    return (
        <div className="template__Container">
            <h1>Gestione: {template?.name}</h1>
            <div style={{marginLeft:'2rem'}}>
                <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            </div>
             {activeIndex === 0 && (
            <UpdateTemplate templateId={id}  />
          )}
          {activeIndex === 1 && (
            <TemplateFiles templateId={id}  />
          )}
        </div>
    )
}

export default TemplateDetail